import MessagesClient from "../clients/messages";
import bookIdTopicList from "../helpers/bookIdTopicList";
import notAllowedRoles from "../helpers/notAllowedRoles";
import notificationsType from "../helpers/notificationsType";
import notificationsExpiringPolicy from "../helpers/notificationsExpiringPolicy";

const state = {
  readMessages: [],
  sentMessages: [],
  messagesByType: {
    myHomeHomeStripe: [],
    myHomeBooksStripe: [],
    myHomeBookBadge: [],
    minisiteBookBadge: [],
  },
};

const getters = {
  readMessages: moduleState => moduleState.readMessages,
  sentMessages: moduleState => moduleState.sentMessages,
  messagesByType: moduleState => moduleState.messagesByType,
  // eslint-disable-next-line no-shadow
  filterNotifications: state => (type, timeId, bookId) => {
    const listIds = state.sentMessages
      .filter(message => {
        return message.push.time_ids.join() === timeId;
      })
      .map(el => el.id);

    const badge = state.messagesByType[type].find(message => {
      return bookId && bookIdTopicList.indexOf(message.push.topic) > -1
        ? message.push.time_ids &&
            message.push.time_ids.join() === timeId &&
            message.push.book_ids &&
            message.push.book_ids.join() === bookId
        : message.push.time_ids && message.push.time_ids.join() === timeId;
    });

    const response = {
      badgeType: badge ? "newActivation" : null,
      notifications: listIds,
    };
    return response;
  },
};

const actions = {
  async checkExpired({ dispatch }, payload) {
    try {
      const { token } = payload;
      const today = new Date();
      const expiredIds = payload.sent
        .filter(message => {
          if (notificationsExpiringPolicy[message.push.topic] < 0) {
            return false;
          }

          const priorDate = new Date().setDate(today.getDate() - notificationsExpiringPolicy[message.push.topic]);
          return new Date(message.created_at) < new Date(priorDate);
        })
        .map(el => el.id);
      // https://css-tricks.com/why-using-reduce-to-sequentially-resolve-promises-works/
      expiredIds.reduce(async (previousPromise, messageId) => {
        await previousPromise;
        return dispatch("markAsRead", { token, messageId });
      }, Promise.resolve());
    } catch (e) {
      console.log(e);
    }
  },
  async fetchMessages({ dispatch }, payload) {
    const { user } = payload;
    try {
      let all = [];
      if (!user.role.includes(notAllowedRoles)) {
        all = await MessagesClient.getAll(user.token);
      }
      const sent = all.filter(message => message.status === "SENT");
      dispatch("filterMessages", sent);
      dispatch("checkExpired", { token: user.token, sent });
    } catch (e) {
      console.log(e);
    }
  },
  async fetchReadMessages({ commit }, payload) {
    const { limit, page, user } = payload;
    try {
      let read = [];
      if (!user.role.includes(notAllowedRoles)) {
        read = await MessagesClient.getAllRead(user.token, limit, page);
      }
      commit("setReadMessages", read);
    } catch (e) {
      console.log(e);
    }
  },
  filterMessages({ commit }, sent) {
    commit("setSentMessages", sent);
    commit(
      "setMessagesMyHomeHomeStripe",
      sent.filter(message => notificationsType.myHomeHomeStripe.indexOf(message.push.topic) > -1)
    );
    commit(
      "setMessagesMyHomeBooksStripe",
      sent.filter(message => notificationsType.myHomeBooksStripe.indexOf(message.push.topic) > -1)
    );
    commit(
      "setMessagesMyHomeBookBadge",
      sent.filter(message => notificationsType.myHomeBookBadge.indexOf(message.push.topic) > -1)
    );
    commit(
      "setMessagesMinisiteBookBadge",
      sent.filter(message => notificationsType.minisiteBookBadge.indexOf(message.push.topic) > -1)
    );
  },
  // eslint-disable-next-line no-shadow
  async markAsRead({ dispatch, getters }, payload) {
    try {
      const messages = getters.sentMessages;
      const read = await MessagesClient.markAsRead(payload.token, payload.messageId);

      const newSentMessages = messages.map(element => {
        if (element.id === read.id) {
          element.status = read.status; // eslint-disable-line no-param-reassign
          element.read_at = read.read_at; // eslint-disable-line no-param-reassign
        }
        return element;
      });

      const sent = newSentMessages.filter(message => message.status === "SENT");
      dispatch("filterMessages", sent);
    } catch (e) {
      console.log(e);
    }
  },
  resetReadMessages({ commit }) {
    commit("setResetReadMessages", []);
  },
};

/* eslint-disable no-param-reassign,no-return-assign */
const mutations = {
  setReadMessages: (oldState, messages) => (oldState.readMessages = [...oldState.readMessages, ...messages]),
  setSentMessages: (oldState, messages) => (oldState.sentMessages = messages),
  setMessagesMyHomeHomeStripe: (oldState, messages) => (oldState.messagesByType.myHomeHomeStripe = messages),
  setMessagesMyHomeBooksStripe: (oldState, messages) => (oldState.messagesByType.myHomeBooksStripe = messages),
  setMessagesMyHomeBookBadge: (oldState, messages) => (oldState.messagesByType.myHomeBookBadge = messages),
  setMessagesMinisiteBookBadge: (oldState, messages) => (oldState.messagesByType.minisiteBookBadge = messages),
  setResetReadMessages: (oldState, messages) => (oldState.readMessages = messages),
  /* eslint-enable no-param-reassign,no-return-assign */
};
export default {
  state,
  getters,
  actions,
  mutations,
};
